import store from '@/store'
import { mitt } from '@/plugins/mitt.js'

function renderResizeBar(el, axis, position, delta) {
  const div = createResizeBarDiv(axis, position)

  div.innerHTML = getButtons(axis)

  div.addEventListener('mousedown', (event) =>
    handleDivMouseDown(event, el, axis, position, delta)
  )

  const toggleButton = div.querySelector('.horizontal-toggle-button')
  if (toggleButton) {
    toggleButton.addEventListener('click', (event) =>
      handleToggleButtonClick(event, el)
    )
  }

  const expandButton = div.querySelector('.horizontal-expand-button')
  if (expandButton) {
    expandButton.addEventListener('click', (event) =>
      handleExpandButtonClick(event, el)
    )
  }

  return div
}

function createResizeBarDiv(axis, position) {
  const div = document.createElement('div')
  div.classList.add(
    'resizeable-directive',
    `resize-bar-${axis}`,
    `position-${position}`
  )
  return div
}

function getButtons(axis) {
  const getHorizontalEmClass = () =>
    store.getters['app/layout'].getRightMenuBottomComponent()
      .resizeableDirectiveHorizontalToggleButtonIcon

  const toggleButton = `<button id="toggleIcon" class="horizontal-toggle-button"><em id="iconElement" class="${getHorizontalEmClass()}"></em></button>`
  const expandButton = `<button id="expandIcon" class="horizontal-expand-button"><em id="expandElement" class="fas fa-expand"></em></button>`
  const verticalIcon = `<svg role="presentation" viewBox="0 0 24 24"><path d="M11 21H9V3H11V21M15 3H13V21H15V3Z" style="fill:var(--color-resizeable-accent);"></path></svg>`

  //FRA remove expand button (https://easyredmine.simpliciti.fr/issues/46895)
  return axis === 'y' ? toggleButton : verticalIcon
}

function handleDivMouseDown(event, el, axis, position, delta) {
  if (
    !event.target.closest('.horizontal-toggle-button') &&
    !event.target.closest('.horizontal-expand-button')
  ) {
    event.preventDefault()

    const initialSize = { width: el.offsetWidth, height: el.offsetHeight }
    const initialMousePos = { x: event.clientX, y: event.clientY }

    const resize = (event) =>
      doResize(event, el, axis, position, initialSize, initialMousePos, delta)
    const stopResize = () => doStopResize(resize, stopResize)

    document.addEventListener('mousemove', resize)
    document.addEventListener('mouseup', stopResize)
  }
}

function doResize(
  event,
  el,
  axis,
  position,
  initialSize,
  initialMousePos,
  delta
) {
  let newSize = 0

  //Handle axis y
  if (axis === 'y') {
    const newYPos = event.clientY - initialMousePos.y
    newSize = initialSize.height + (position === 'top' ? -1 : 1) * newYPos

    if (newSize < 20) newSize = 0

    newSize = Math.max(delta, Math.min(newSize, window.innerHeight - delta))
    void store.dispatch(
      'app/setRightMenuBottomState',
      newSize === 0 ? 'hidden' : 'visible-default'
    )

    el.style.height = `${newSize}px`

    //Store new height
    void store.dispatch('app/setRightMenuBottomCurrentHeight', newSize)
  } else if (axis === 'x') {
    const newXPos = event.clientX - initialMousePos.x
    newSize = initialSize.width + (position === 'left' ? -1 : 1) * newXPos
    newSize = Math.max(delta, Math.min(newSize, window.innerWidth - delta))

    el.style.width = `${newSize}px`
  }

  void store.dispatch('app/setIsLayoutResizeInProgress', true)
}

function doStopResize(resize, stopResize) {
  void store.dispatch('app/setIsLayoutResizeInProgress', false)
  document.removeEventListener('mousemove', resize)
  document.removeEventListener('mouseup', stopResize)
  updateIcon()
  setTimeout(() => {
    mitt.emit('resizeable_stop')
    console.log('resizable', 'resizeable_stop')
  }, 200)
}

function handleToggleButtonClick(event, el) {
  event.preventDefault()
  toggleCollapse(el)
}

function handleExpandButtonClick(event, el) {
  event.preventDefault()
  expandCollapse(el)
}

function toggleCollapse(el) {
  if (store.getters['app/toggleInProgress']) {
    return
  }

  void store.dispatch('app/setIsLayoutToggleInProgress', true)

  const layout = store.getters['app/layout']
  const isCollapsed = layout.isRightMenuBottomCollapsed

  let newState = isCollapsed ? 'visible-default' : 'hidden'

  store
    .dispatch('app/setRightMenuBottomState', newState)
    .then(() => {
      const updatedLayout = store.getters['app/layout']
      const newSize =
        updatedLayout.getRightMenuBottomComponent().rightMenuBottomHeight

      el.style.height = `${newSize}px`

      //Store new height
      void store.dispatch('app/setRightMenuBottomCurrentHeight', newSize)

      updateIcon()
      void store.dispatch('app/setIsLayoutToggleInProgress', false)
    })
    .catch(() => {
      void store.dispatch('app/setIsLayoutToggleInProgress', false)
    })
    .finally(() => {
      mitt.emit('resizeable_stop')
      console.log('resizable', 'resizeable_stop')
    })
}

function expandCollapse(el) {
  if (store.getters['app/toggleInProgress']) {
    return
  }

  void store.dispatch('app/setIsLayoutToggleInProgress', true)

  const layout = store.getters['app/layout']
  const isExpanded = layout.isRightMenuBottomExpanded

  let newState = isExpanded ? 'visible-default' : 'visible-expanded'

  store
    .dispatch('app/setRightMenuBottomState', newState)
    .then(() => {
      const updatedLayout = store.getters['app/layout']
      const newSize =
        updatedLayout.getRightMenuBottomComponent().rightMenuBottomHeight

      el.style.height = `${newSize}px`
      updateIcon()
      //Store new height
      void store.dispatch('app/setRightMenuBottomCurrentHeight', newSize)
      void store.dispatch('app/setIsLayoutToggleInProgress', false)
    })
    .catch(() => {
      void store.dispatch('app/setIsLayoutToggleInProgress', false)
    })
    .finally(() => {
      mitt.emit('resizeable_stop')
      console.log('resizable', 'resizeable_stop')
    })
}

function updateIcon() {
  const iconElement = document.getElementById('iconElement')
  const expandElement = document.getElementById('expandElement')
  const layout = store.getters['app/layout']
  const isCollapsed = layout.isRightMenuBottomCollapsed
  const isExpanded = layout.isRightMenuBottomExpanded

  let toggleIconClass = ''
  let expandIconClass = 'fas fa-expand'

  if (isCollapsed) {
    toggleIconClass = 'fas fa-chevron-up'
  } else {
    toggleIconClass = 'fas fa-chevron-down'
  }

  if (isExpanded) {
    expandIconClass = 'fas fa-compress'
  }

  iconElement.className = toggleIconClass
  if (expandElement) {
    expandElement.className = expandIconClass
  }
}

export default {
  bind(el, binding, vnode) {
    const enabled = binding.value.enabled || false
    const expand = binding.value.expand || false

    if (enabled) {
      const axis = binding.value.axis || 'y'
      const position = binding.value.position || 'bottom'
      const delta = binding.value.delta || (axis === 'y' ? 0 : 50)
      const resizeBar = renderResizeBar(el, axis, position, delta, expand)

      vnode.context.$nextTick(() => {
        vnode.elm.appendChild(resizeBar)
      })
    }
  },
}
